var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgActions = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 14,
  viewBox: "0 0 10 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M6.003 0c.55 0 .833.426.639.931L4.697 5.987l4.326-.897c.54-.112.977.254.977.797v.151c0 .357-.18.708-.456.942a1.9 1.9 0 0 1-.343.544L3.68 14h-.003c-.55 0-.84-.417-.642-.944l1.868-4.962-3.926.816C.437 9.022 0 8.656 0 8.113v-.151c0-.334.157-.662.403-.895.043-.167.16-.376.358-.619L6 0z"
})));
export default SvgActions;